import React, { useState } from 'react';
import { Grid, Button, TextField } from '@mui/material';
import {
	SchedulerDepartment,
	updateDepartment,
} from '../../../../core/API/scheduler';
import { isDepartmentNameValid } from '../../../../module/schedule/utils/scheduleDepartmentUtils';
import styles from '../SchedulerSetting.module.scss';

interface EditDepartmentProps {
	department: SchedulerDepartment;
	handleBackClick?: () => void;
	onDepartmentUpdated?: () => void;
	existingDepartments: SchedulerDepartment[];
}

const EditDepartment: React.FC<EditDepartmentProps> = ({
	department,
	handleBackClick,
	onDepartmentUpdated,
	existingDepartments,
}) => {
	const [name, setName] = useState(department.name || '');
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError(null);

		const validationError = isDepartmentNameValid(name, existingDepartments, department.id);
		if (validationError) {
			setError(validationError);
			return;
		}

		try {
			setIsSubmitting(true);
			await updateDepartment(department.id, { name: name.trim() });
			onDepartmentUpdated?.();
			setTimeout(() => {
				handleBackClick?.();
			}, 500);
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.['hydra:description'] ||
				err?.response?.data?.message ||
				(err instanceof Error ? err.message : 'Failed to update department');
			setError(errorMessage);
			setIsSubmitting(false);
		}
	};

	return (
		<div className={styles.editJobCode}>
			<Grid container direction="column" spacing={2} pl={2}>
				<Grid container direction="row" justifyContent="space-between">
					<Button className={styles.backButton} onClick={handleBackClick} variant="contained">
						Back
					</Button>
					<Button
						className={styles.submitButton}
						onClick={handleSubmit}
						disabled={isSubmitting}
						variant="contained"
					>
						{isSubmitting ? 'Saving...' : 'Save'}
					</Button>
				</Grid>
				<Grid>
					<h1 className={styles.formTitle}>Edit Department</h1>
				</Grid>
			</Grid>

			<form className={styles.formContainer} onSubmit={handleSubmit}>
				{error && <div style={{ color: '#d32f2f', marginBottom: 16 }}>{error}</div>}

				<TextField
					label="Department Name"
					name="name"
					value={name}
					onChange={(e) => setName(e.target.value)}
					placeholder="Enter department name"
					className={styles.input}
					margin="normal"
					fullWidth
					required
				/>
			</form>
		</div>
	);
};

export default EditDepartment;
